/* Referral persistence: a referred visitor's code lives in localStorage AND a
   30-day cookie, so the invitation survives cleared storage and late signups.
   The code attaches to their account once, right after their first auth. */

const CODE_KEY = "solis_ref";
const BRAND_KEY = "solis_ref_brand";
const MAX_AGE = 30 * 24 * 3600; // 30 days

const setCookie = (k, v) => {
  document.cookie = `${k}=${encodeURIComponent(v)}; max-age=${MAX_AGE}; path=/; samesite=lax`;
};

const getCookie = (k) => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${k}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : "";
};

const dropCookie = (k) => {
  document.cookie = `${k}=; max-age=0; path=/`;
};

export function setReferral(code, brand) {
  const c = (code || "").toLowerCase();
  if (!c) return;
  localStorage.setItem(CODE_KEY, c);
  setCookie(CODE_KEY, c);
  if (brand) {
    localStorage.setItem(BRAND_KEY, brand);
    setCookie(BRAND_KEY, brand);
  }
}

export function getReferral() {
  return localStorage.getItem(CODE_KEY) || getCookie(CODE_KEY) || "";
}

export function getReferralBrand() {
  return localStorage.getItem(BRAND_KEY) || getCookie(BRAND_KEY) || "";
}

export function setReferralBrand(brand) {
  if (!brand) return;
  localStorage.setItem(BRAND_KEY, brand);
  setCookie(BRAND_KEY, brand);
}

export function clearReferral() {
  localStorage.removeItem(CODE_KEY);
  localStorage.removeItem(BRAND_KEY);
  dropCookie(CODE_KEY);
  dropCookie(BRAND_KEY);
}
